// extracted by mini-css-extract-plugin
module.exports = {"sections-separator":"SectionSeparator_sections-separator__2Q7xq"};